import { render } from "./LayoutsListPopup.vue?vue&type=template&id=6783ab27&scoped=true"
import script from "./LayoutsListPopup.vue?vue&type=script&lang=js"
export * from "./LayoutsListPopup.vue?vue&type=script&lang=js"

import "./LayoutsListPopup.vue?vue&type=style&index=0&id=6783ab27&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6783ab27"]])

export default __exports__